let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g0ukK")).then(() => parcelRequire('1CggD'));